/**
 * This is an initial enum for unified usage of a data language key.
 * This should be defined in openapi to have the same enum for front- and backend later.
 */
export enum DataLanguageKey {
  DE = "de",
  EN = "en",
}
